import pdfMake from "pdfmake/build/pdfmake.min.js";
import vfs_fonts from "pdfmake/build/vfs_fonts.js";
pdfMake.vfs = vfs_fonts.pdfMake.vfs;

export default {
	exportPDF(doc, name) {
		pdfMake.createPdf(doc).download(name);
	},

	exportCSV(rows, filenameFields) {
		var processRow = function(row) {
			var finalVal = "";
			for (var j = 0; j < row.length; j++) {
				var innerValue = row[j] === null ? "" : row[j].toString();
				if (row[j] instanceof Date) {
					innerValue = row[j].toLocaleString();
				}
				var result = innerValue.replace(/"/g, '""'); //Escape single quotes
				if (result.search(/("|,|\n)/g) >= 0)
					//Escape other problematic characters
					result = '"' + result + '"';
				if (j > 0) finalVal += ",";
				finalVal += result;
			}
			return finalVal + "\n";
		};

		var processFileName = function(filenameFields) {
			var filename = "";
			for (var i = 0; i < filenameFields.length; i++) {
				var field = filenameFields[i];
				field = field.replace(/\s/g, "_"); //Replace white space with dashes
				field = field.replace(/<|>|\/|\\|:|"|\||\?|\*/g, "#"); //Replace forbidden characters with pound signs 'cause why not

				filename = filename + (i > 0 ? " " : "") + field;
			}

			return filename + ".csv";
		};

		//var csvFile = "sep=,\n";
		var csvFile = "";
		for (var i = 0; i < rows.length; i++) {
			csvFile += processRow(rows[i]);
		}

		var blob = new Blob([csvFile], { type: "text/csv;charset=utf-8;" });
		if (navigator.msSaveBlob) {
			// IE 10+
			navigator.msSaveBlob(blob, filename);
		} else {
			var link = document.createElement("a");
			if (link.download !== undefined) {
				// feature detection
				// Browsers that support HTML5 download attribute
				var url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", processFileName(filenameFields));
				link.style.visibility = "hidden";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		}
	},

	CSVToArray(strData, strDelimiter) {
		// Check to see if the delimiter is defined. If not,
		// then default to comma.
		strDelimiter = strDelimiter || ",";
		// Create a regular expression to parse the CSV values.
		var objPattern = new RegExp(
			// Delimiters.
			"(\\" +
				strDelimiter +
				"|\\r?\\n|\\r|^)" +
				// Quoted fields.
				'(?:"([^"]*(?:""[^"]*)*)"|' +
				// Standard fields.
				'([^"\\' +
				strDelimiter +
				"\\r\\n]*))",
			"gi"
		);
		// Create an array to hold our data. Give the array
		// a default empty first row.
		var arrData = [[]];
		// Create an array to hold our individual pattern
		// matching groups.
		var arrMatches = null;
		// Keep looping over the regular expression matches
		// until we can no longer find a match.
		while ((arrMatches = objPattern.exec(strData))) {
			// Get the delimiter that was found.
			var strMatchedDelimiter = arrMatches[1];
			// Check to see if the given delimiter has a length
			// (is not the start of string) and if it matches
			// field delimiter. If id does not, then we know
			// that this delimiter is a row delimiter.
			if (
				strMatchedDelimiter.length &&
				strMatchedDelimiter != strDelimiter
			) {
				// Since we have reached a new row of data,
				// add an empty row to our data array.
				arrData.push([]);
			}
			// Now that we have our delimiter out of the way,
			// let's check to see which kind of value we
			// captured (quoted or unquoted).
			if (arrMatches[2]) {
				// We found a quoted value. When we capture
				// this value, unescape any double quotes.
				var strMatchedValue = arrMatches[2].replace(
					new RegExp('""', "g"),
					'"'
				);
			} else {
				// We found a non-quoted value.
				var strMatchedValue = arrMatches[3];
			}
			// Now that we have our value string, let's add
			// it to the data array.
			arrData[arrData.length - 1].push(strMatchedValue);
		}
		// Return the parsed data.
		return arrData;
	}
};



// WEBPACK FOOTER //
// ./src/services/Exporters/Common.js